import React from 'react';
import Link from '@mui/material/Link';
import useBundleTranslation from 'i18n';

export default function LLMLogLink({ sessionUid }: { sessionUid: string }) {
    const { t } = useBundleTranslation(['app/concierge/widget']);

    const onClick = () => {
        window.MiNamespace.render({ component: 'concierge_llm_log', props: { session_uid: sessionUid } });
    };
    return (
        <Link sx={{ cursor: 'pointer' }} onClick={onClick}>
            {t('llm_log')}
        </Link>
    );
}
